<template>
  <div>
    <!-- 搜索栏 -->
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input
            v-model="searchForm.userName"
            placeholder="输入用户名"
            clearable
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-select
            v-model="searchForm.role"
            placeholder="选择角色"
            clearable
            style="width: 100%"
        >
          <el-option
              v-for="role in roles"
              :key="role"
              :label="role"
              :value="role"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="fetchData">搜索</el-button>
        <el-button @click="resetSearch">重置</el-button>
        <el-button type="success" @click="openAddDialog">新增管理员</el-button>
      </el-col>
    </el-row>

    <!-- 管理员信息表格 -->
    <el-table :data="adminList" style="width: 100%" stripe>
      <el-table-column label="用户名" prop="userName" :min-width="120"></el-table-column>
      <el-table-column label="姓名" prop="name" :min-width="120"></el-table-column>
      <el-table-column label="角色" prop="role" :min-width="150"></el-table-column>
      <el-table-column label="所属机构" prop="organizationID" :min-width="150">
<!--        <template v-slot="{ row }">-->
<!--          {{ getorgName(row.organizationID) }}-->
<!--        </template>-->
      </el-table-column>

      <el-table-column label="创建时间" prop="createDate" :min-width="200"></el-table-column>
      <el-table-column label="邮箱" prop="emaiAddress" :min-width="200"></el-table-column>
      <el-table-column label="电话" prop="phone" :min-width="150"></el-table-column>
      <el-table-column label="添加管理员权限" :min-width="150">
        <template v-slot="{ row }">
          <!-- 根据 row.canAddAdmin 的值显示不同的按钮 -->
          <el-button
              v-if="row.canAddAdmin"
          size="small"
          type="danger"
          @click="handleClick(row, 'canAddAdmin')"
          >
          禁用权限
          </el-button>
          <el-button
              v-else
          size="small"
          type="success"
          @click="handleClick(row, 'canAddAdmin')"
          >
          授权权限
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="删除管理员权限" :min-width="150">
        <template v-slot="{ row }">

          <el-button
              v-if="row.canDeleteAdmin"
          size="small"
          type="danger"
          @click="handleClick(row, 'canDeleteAdmin')"
          >
          禁用权限
          </el-button>
          <el-button
              v-else
          size="small"
          type="success"
          @click="handleClick(row, 'canDeleteAdmin')"
          >
          授权权限
          </el-button>
        </template>
      </el-table-column>



      <!-- 操作列 -->
      <el-table-column label="操作" :min-width="200">
        <template v-slot="{ row }">
          <el-button size="small" type="warning" @click="openEditDialog(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteUser(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        v-if="totalCount > 0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        layout="total, prev, pager, next, jumper"
        @click="handlePageChange"
    ></el-pagination>

    <!-- 新增/编辑管理员弹窗 -->
    <el-dialog :title="editMode ? '编辑管理员' : '新增管理员'" v-model="dialogVisible">
      <el-form :model="dialogForm" label-width="80px">
        <el-form-item label="用户名">
          <el-input v-model="dialogForm.userName" :disabled="editMode"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="dialogForm.Password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="dialogForm.name"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="dialogForm.role" placeholder="请选择角色">
            <el-option
                v-for="role in roles"
                :key="role"
                :label="role"
                :value="role"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="机构">
          <el-select v-model="dialogForm.OrganizationID" placeholder="请选择机构">
            <el-option
                v-for="role in organizations"
                :key="role.organizationID"
                :label="role.orgName"
                :value="role.organizationID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="dialogForm.emaiAddress"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="dialogForm.phone"></el-input>
        </el-form-item>
        <!-- 添加管理员权限 -->
        <el-form-item label="添加权限">
          <el-switch
              v-model="dialogForm.canAddAdmin"
              active-text="允许"
              inactive-text="不允许"
              active-value="true"
              inactive-value="false"

          ></el-switch>
        </el-form-item>

        <!-- 删除管理员权限 -->
        <el-form-item label="删除权限">
          <el-switch
              v-model="dialogForm.canDeleteAdmin"
              active-text="允许"
              inactive-text="不允许"
              active-value="true"
              inactive-value="false"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitDialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/axios";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      organizations:[],
      roles: ["机构管理员", "视频审核管理员"],
      searchForm: {
        userName: "",
        role: "",
      },
      adminList: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      editMode: false,
      dialogForm: {
        userName: "",
        name: "",
        role: "",
        email: "",
        phone: "",
        canDeleteAdmin:true,
        canAddAdmin:false,
      },
    };
  },
  methods: {
    fetchData() {
      const params = {
        userName: this.searchForm.userName,
        role: this.searchForm.role || "机构管理员",
        page: this.currentPage,
        size: this.pageSize,
      };
      axios
          .get("/admin/users", { params })
          .then((response) => {
            const { data } = response;
            this.adminList = data.data;
            this.totalCount = data.total;
          })
          .catch(() => {
            ElMessage.error("获取管理员信息失败");
          });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    resetSearch() {
      this.searchForm = {
        userName: "",
        role: "",
      };
      this.fetchData();
    },
    openAddDialog() {
      this.dialogVisible = true;
      this.editMode = false;
      this.dialogForm = {
        userName: "",
        name: "",
        role: "",
        emaiAddress: "",
        phone: "",
        OrganizationID:'',
        Password:'',
        canAddAdmin: false,
        canDeleteAdmin: false,
      };
    },
    openEditDialog(row) {
      this.dialogVisible = true;
      this.editMode = true;

      console.log(row)
      this.dialogForm = { ...row };
      // 确保权限字段为布尔值
      // this.dialogForm.canAddAdmin = Boolean(row.canAddAdmin);
      // this.dialogForm.canDeleteAdmin = Boolean(row.canDeleteAdmin);

      console.log(this.dialogForm)
    },
    submitDialog() {
      const api = this.editMode ? "/admin/editUser" : "/admin/addUser";
      axios
          .post(api, this.dialogForm)
          .then(() => {
            ElMessage.success(this.editMode ? "编辑成功" : "新增成功");
            this.dialogVisible = false;
            this.fetchData();
          })
          .catch(() => {
            ElMessage.error(this.editMode ? "编辑失败" : "新增失败");
          });
    },
    deleteUser(row) {
      axios
          .post("/admin/deleteUser", { userID: row.userID })
          .then(() => {
            ElMessage.success("删除成功");
            this.fetchData();
          })
          .catch(() => {
            ElMessage.error("删除失败");
          });
    },
    handleClick(row, permission) {
      // 只有在点击事件触发时才更新权限
      this.updatePermission(row, permission);
    },
    updatePermission(row, field) {

      console.log(row[field])
      axios
          .post("/admin/updatePermission", {
            userID: row.userID,
            [field]: row[field],
          })
          .then(() => {
            ElMessage.success("权限更新成功");

            this.fetchData()
          })
          .catch(() => {
            ElMessage.error("权限更新失败");
          });
    },
    getorgName(id){

      console.log(id)
   // return    this.organizations.find((o) => o.organizationID === id).orgName

      return 'zhb'
    }
  },
  created() {
    this.fetchData();
    axios.get('/organization/orglist').then(res => {
      this.organizations = res.data.data
})
  },
};
</script>

<style scoped>
.search-row {
  margin-bottom: 20px;
}
.el-switch__label {
  white-space: nowrap;
  display: inline-block;
  width: auto; /* 设置为auto，可以避免文字被截断 */
}

</style>
